import { render, staticRenderFns } from "./ReportsSection.vue?vue&type=template&id=276c8fd7&scoped=true"
import script from "./ReportsSection.vue?vue&type=script&lang=js"
export * from "./ReportsSection.vue?vue&type=script&lang=js"
import style0 from "./ReportsSection.vue?vue&type=style&index=0&id=276c8fd7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276c8fd7",
  null
  
)

export default component.exports